module.exports = __webpack_public_path__ + "static/lighting-carousel-basic-21fb386066264414bb4c398b79eb73c0.png";